import * as React from 'react';
const classNames = require('classnames');

export interface CheckboxProps {
	id?: string;
	name: string;
	label: any;
	checked?: boolean;
	value?: string;
	onChange?: (value?: {}) => void;
	onBlur?: (value?: {}) => void;
	style?: {};
	className?: string;
	disabled?: boolean;
	conditionalChildren?: {};
}

const Checkbox: React.StatelessComponent<CheckboxProps> = props => {
	return (
		<div className={classNames('form-check-wrapper', props.className)}>
			<div
				className={classNames('form-check custom-control custom-checkbox', {
					disabled: props.disabled
				})}
			>
				<input
					type="checkbox"
					name={props.name}
					checked={props.checked || false}
					value={props.value}
					id={props.id || props.name}
					onChange={props.onChange}
					onBlur={props.onBlur}
					className="form-check-input custom-control-input"
				/>
				<label className="form-check-label custom-control-label" htmlFor={props.name}>
					<span dangerouslySetInnerHTML={{ __html: props.label }} />
				</label>
			</div>
			{props.conditionalChildren}
		</div>
	);
};

export default Checkbox;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/Checkbox.tsx